import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  ListItem,
  ListItemIcon,
  ListItemText,
  Slide,
} from "@mui/material";
import React, { useContext } from "react";
import { useEffect } from "react";
import CreditRiskCard from "../../../Components/CrifCard/CreditCard";
import {
  Exceptional,
  Fair,
  Good,
  NewToCredit,
  NotAvailable,
  Poor,
  VeryGood,
} from "../../../Components/StatusChip";
import { GlobalContext } from "../../../Context/GlobalContext";
import { f, responseFormat, scoreCheckText } from "../../../utility/Formater";
import { decryptData, fetchRejectedCoapps } from "../../../api";
import { useState } from "react";
import CreditEngineComp from "../../../Components/CreditEngineComp/CreditEngineComp";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { UserContext } from "../../../Context/UserContext";
import { toast } from "react-toastify";
import useApplication from "../../../hooks/useApplication";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CoCustomerDetails = ({ setOpenCSTC }) => {
  const { updateDetailState } = useContext(GlobalContext);
  const [updateDetails, setUpdateDetails] = updateDetailState;
  const { user } = useContext(UserContext);
  const { getApplicationDetails } = useApplication();
  const [rejectedCoapplicants, setRejectedCoapplicants] = useState([]);
  const [creditEngineData, setCreditEngineData] = React.useState({
    open: false,
    type: "customer",
  });

  const [crifData, setCrifData] = useState({});
  const [openCrifData, setOpenCrifData] = useState({
    open: false,
    loading: false,
  });

  const fetchRejectedCoapplicants = async (appId) => {
    const { data } = await fetchRejectedCoapps(appId);
    if (data?.status) {
      setRejectedCoapplicants(data?.data);
    }
  };

  const handleClickOpen = () => {
    setOpenCrifData({
      open: true,
      loading: true,
    });
  };

  const handleClose = () => {
    setOpenCrifData({
      open: false,
      loading: false,
    });
  };

  const handleViewCrif = async () => {
    setOpenCrifData({
      open: true,
      loading: true,
    });
    try {
      let { data } = await decryptData({
        data: updateDetails?.co_crif_data,
      });
      if (data?.status) {
        setCrifData(data?.data);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
    setOpenCrifData({ open: true, loading: false });
  };

  useEffect(() => {
    fetchRejectedCoapplicants(updateDetails?.application_id);
  }, [updateDetails]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="overview-card">
            <div className="card-content">
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <p className="sub-heading">Basic Details</p>
                  <ListItemComp
                    heading={"Name:"}
                    text={f(updateDetails?.co_app_customer_name)}
                  />
                  <ListItemComp
                    heading={"Mobile:"}
                    text={f(updateDetails?.co_app_mobile_number)}
                  />
                  <ListItemComp
                    heading={"Email:"}
                    text={f(updateDetails?.co_app_email)}
                  />
                  <ListItemComp
                    heading={"Gender:"}
                    text={f(updateDetails?.co_app_gender)}
                  />
                  {Number(user?.role) !== 3 && (
                    <ListItemComp
                      heading={"Income:"}
                      text={f(updateDetails?.co_app_income)}
                    />
                  )}
                  {Number(user?.role) !== 3 && (
                    <ListItemComp
                      heading={"Education:"}
                      text={f(updateDetails?.co_app_education)}
                    />
                  )}
                  <ListItemComp
                    heading={"Relationship with borrower:"}
                    text={f(updateDetails?.co_app_relation_borrower)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <p className="sub-heading">Pan Details</p>
                  <ListItemComp
                    heading={"Name:"}
                    text={f(updateDetails?.co_app_customer_name)}
                  />
                  <ListItemComp
                    heading={"Number:"}
                    text={f(updateDetails?.co_app_pan_number)}
                  />

                  <div className="pe-4">
                    <hr />
                  </div>

                  <p className="sub-heading">Aadhaar Details</p>
                  <ListItemComp
                    heading={"Name:"}
                    text={f(updateDetails?.co_app_aadhaar_name)}
                  />
                  {/* <ListItemComp
                    heading={"UID:"}
                    text={f(updateDetails?.co_app_aadhaar_number)}
                  /> */}
                  {[1,5].includes(Number(user?.role)) && <ListItemComp
                    heading={"UID:"}
                    text={
                      [1,5].includes(Number(user?.role)) &&
                      updateDetails?.co_app_aadhaar_number_unmasked
                        ? f(updateDetails?.co_app_aadhaar_number_unmasked)
                        : f(updateDetails?.co_app_aadhaar_number)
                    }
                  />}
                  <ListItemComp
                    heading={"Gender:"}
                    text={f(updateDetails?.co_app_aadhaar_gender)}
                  />
                  <ListItemComp
                    heading={"Address:"}
                    text={f(updateDetails?.co_app_aadhaar_address)}
                  />
                  <ListItemComp
                    heading={"Aadhaar Linked Mobile No.:"}
                    text={f(updateDetails?.co_app_aadhaar_mobile_number_masked)}
                  />
                  <ListItemComp
                    heading={"Aadhaar Linked Mobile Match:"}
                    text={f(
                      updateDetails?.co_app_aadhaar_mobile_number_matched
                    )}
                  />
                </Grid>
                <Grid item xs={5}>
                  <p className="sub-heading">Residential Address</p>
                  {Number(user?.role) !== 3 && (
                    <ListItemComp
                      heading={"Is Property Owned:"}
                      text={f(
                        updateDetails?.co_app_current_residential_owned,
                        "bool"
                      )}
                    />
                  )}
                  {Number(user?.role) !== 3 && (
                    <ListItemComp
                      heading={"Owned By:"}
                      text={f(updateDetails?.co_app_owned_by)}
                    />
                  )}
                  <ListItemComp
                    heading={"City:"}
                    text={f(updateDetails?.co_app_city)}
                  />
                  <ListItemComp
                    heading={"District:"}
                    text={f(updateDetails?.co_app_district)}
                  />
                  <ListItemComp
                    heading={"State:"}
                    text={f(updateDetails?.co_app_state)}
                  />
                  <ListItemComp
                    heading={"Pincode:"}
                    text={f(updateDetails?.co_app_pincode)}
                  />
                  <ListItemComp
                    heading={"Address:"}
                    text={f(updateDetails?.co_app_current_residential_address)}
                  />
                </Grid>
              </Grid>
            </div>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className="overview-card">
            <p className="card-heading">
              Credit Engine Data
              {[1,5].includes(Number(user?.role)) &&
                updateDetails?.co_app_creation_stage !==
                  "CO_CUSTOMER_BASIC_DETAILS" && (
                  <span
                    style={{
                      float: "right",
                      cursor: "pointer",
                      padding: "2px 10px",
                      background: "#1d1b31",
                      color: "white",
                      borderRadius: "20px",
                    }}
                    onClick={() => {
                      // handleRunEngine("customer");
                      setCreditEngineData({ open: true, type: "co_customer" });
                    }}
                  >
                    <AutorenewIcon sx={{ fontSize: 16 }} />
                    Run Engine
                  </span>
                )}
            </p>
            <div className="card-content">
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  {/* <ListItemComp
                    heading={"Eligibility:"}
                    text={f(updateDetails?.co_credit_eligible, "bool")}
                  /> */}
                  <ListItemComp
                    heading={"Score Remark:"}
                    text={scoreCheckText(updateDetails?.co_app_crif_score)}
                  />
                  {Number(user?.role) !== 3 && (
                    <ListItemComp
                      heading={"Response:"}
                      text={responseFormat(
                        updateDetails?.co_credit_response,
                        updateDetails?.co_credit_eligible
                      )}
                    />
                  )}
                  {Number(user?.role) !== 3 && (
                    <ListItemComp
                      heading={"Customer Distance:"}
                      text={
                        updateDetails?.credit_engine?.details?.current_distance?.toFixed(
                          2
                        ) ?? 0
                      }
                    />
                  )}
                  {Number(user?.role) !== 3 && (
                    <ListItemComp
                      heading={"Co-Customer Distance:"}
                      text={
                        updateDetails?.coApplicantExist ? (
                          updateDetails?.co_app_dealer_distance?.toFixed(2) ?? 0
                        ) : (
                          <NotAvailable />
                        )
                      }
                    />
                  )}
                </Grid>

                <Grid item xs={6} className="pb-2">
                  <CreditRiskCard
                    application={{
                      credit_pull: {
                        credit_data: {
                          crif_score: updateDetails?.co_app_crif_score,
                        },
                      },
                    }}
                  />
                </Grid>

                {Number(user?.role) === 1 &&
                  updateDetails?.co_crif_data !== null && (
                    <Grid item xs={12}>
                      <hr />

                      <Button
                        onClick={() => {
                          handleViewCrif();
                        }}
                      >
                        <RemoveRedEyeIcon sx={{ mr: 1 }} /> View Report
                      </Button>
                    </Grid>
                  )}
              </Grid>
            </div>
          </div>
        </Grid>

        {rejectedCoapplicants.length !== 0 && (
          <Grid item xs={6}>
            <div
              style={{
                height: "300px",
                overflowX: "hidden",
                overflowY: "auto",
              }}
              className="overview-card"
            >
              <p className="card-heading">Rejected Co-Applicants</p>
              <div className="card-content">
                <Grid container spacing={2}>
                  {rejectedCoapplicants?.map((rejected, index) => {
                    return (
                      <>
                        <Grid item xs={12}>
                          <ListItemComp
                            heading="Name"
                            text={rejected?.pan_details?.name}
                          />
                          <ListItemComp
                            heading="Score"
                            text={
                              rejected?.credit_pull?.credit_data?.crif_score
                            }
                          />
                          <ListItemComp
                            heading="Reason"
                            text={rejected?.credit_engine?.message}
                          />
                          <ListItemComp
                            heading="Pan Number"
                            text={rejected?.pan_details?.number}
                          />
                          <ListItemComp
                            heading="Date of Birth"
                            text={rejected?.dob}
                          />{" "}
                          <ListItemComp
                            heading="Mobile Number"
                            text={rejected?.mobile_number}
                          />{" "}
                          <ListItemComp
                            heading="Gender"
                            text={rejected?.gender}
                          />
                          <ListItemComp
                            heading="Pincode"
                            text={
                              rejected?.aadhaar_details?.address_information
                                ?.pincode
                            }
                          />
                          {/* {Object.keys(rejected).map((key) => {
                          return (
                            <>
                              <ListItemComp
                                heading={key}
                                text={rejected[key]}
                              />
                             
                            </>
                          );
                        })} */}
                          {index !== rejectedCoapplicants.length - 1 ? (
                            <hr />
                          ) : (
                            " "
                          )}
                          {/* <ListItemComp
                    heading={"Eligibility:"}
                    text={f(updateDetails?.co_credit_eligible, "bool")}
                  /> */}
                        </Grid>
                      </>
                    );
                  })}

                  {/* <Grid item xs={6} className="pb-2">
                  <CreditRiskCard
                    application={{
                      credit_pull: {
                        credit_data: { crif_score: updateDetails?.crif_score },
                      },
                    }}
                  />
                </Grid> */}
                </Grid>
              </div>
            </div>
          </Grid>
        )}
      </Grid>
      <CreditEngineComp
        open={creditEngineData?.open}
        type={creditEngineData?.type}
        handleClose={() => {
          setCreditEngineData({ open: false, type: "" });
        }}
        handleReload={() => {
          getApplicationDetails(updateDetails?.application_id);
        }}
      />

      <Dialog
        open={openCrifData?.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
      >
        <DialogTitle>Crif Report</DialogTitle>
        <DialogContent>
          {openCrifData?.loading ? (
            <p>
              {" "}
              <CircularProgress size={12} /> Loading
            </p>
          ) : (
            <pre>{JSON.stringify(crifData, null, 2)}</pre>
          )}
          {/* <ReactJson
            src={crifData}
            collapsed={false}
            displayDataTypes={false}
            displayArrayKey={false}
          /> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CoCustomerDetails;

const ListItemComp = ({ icon, heading, text }) => {
  return (
    <ListItem disablePadding>
      <ListItemIcon className="list-key">
        {
          <span>
            {icon && icon}
            {heading}
          </span>
        }
      </ListItemIcon>
      <ListItemText
        primaryTypographyProps={{ fontSize: "13px" }}
        className="list-value"
        primary={text}
      />
    </ListItem>
  );
};
